import React, { useState } from 'react'
import { cn } from '@stratascratch/ui'
import { PortableText } from '@portabletext/react'
import { buildImageObj } from '../lib/helpers'
import { imageUrlFor } from '../lib/image-url'
import { AuthorsItem } from '../types/blogPost'

interface AuthorListProps {
  items: AuthorsItem[]
}

function AuthorList({ items }: AuthorListProps) {
  const [show, setShow] = useState(false)

  return (
    <ul className="my-4">
      {items.map(({ author, _key }) => (
        <React.Fragment key={_key}>
          <li className="my-2">
            <div className="flex gap-4">
              {author && author.image && author.image.asset && (
                <img
                  className="bg-(--bg-color-secondary) size-12 rounded-full object-cover"
                  src={imageUrlFor(buildImageObj(author.image))
                    .width(100)
                    .height(100)
                    .fit('crop')
                    .url()}
                  alt="Author Avatar"
                />
              )}
              <div>
                <span className="text-(--text-color-light) text-sm">
                  Written by:
                </span>
                <p>{author.name || <em>Missing name</em>}</p>
                <button
                  className={cn(
                    'text-(--color-link) mt-2 block cursor-pointer text-sm',
                    show && 'text-(--text-color-dim)',
                  )}
                  onClick={() => setShow(!show)}
                >
                  Author Bio...
                </button>
                {show && (
                  <div className="mt-2">
                    <PortableText
                      value={author._rawBio}
                      components={{
                        block: {
                          normal: ({ children }) => (
                            <p className="text-sm/6">{children}</p>
                          ),
                        },
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
          </li>
        </React.Fragment>
      ))}
    </ul>
  )
}

export default AuthorList
